var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"th flex items-center pointer button",class:{'grow' : _vm.enabled},staticStyle:{"user-select":"none"},on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }